// Hakukoneiden ja somejakojen asetukset: mitkä reitit saavat oman
// esikatselunsa ja millä kuvalla. Tekstit ovat translations.js:n t.meta-avaimissa.
// Lukija: src/components/PageMeta.jsx (selain) ja scripts/write-route-meta.mjs
// (build). Skripti lataa tämän tiedoston sellaisenaan Nodessa, joten ei importteja.
//
// Uusi sivu: lisää reitti tähän, tekstit t.meta.<avain>:iin ja rivi
// public/sitemap.xml:ään. Netlifyn reittisäännöt skripti kirjoittaa itse.

export const seo = {
  pages: [
    // Portti mainitsee molemmat puolet; jakokuvana Hetki-puolen kuva.
    { path: "/", key: "portti", side: "portti", image: "/images/og/hetki.jpg" },
    { path: "/hetki", key: "hetki", side: "hetki", image: "/images/og/hetki.jpg" },
    { path: "/tyot", key: "tyot", side: "hetki", image: "/images/og/hetki.jpg" },
    { path: "/palvelut", key: "palvelut", side: "hetki", image: "/images/og/hetki.jpg" },
    { path: "/yhteys", key: "yhteys", side: "hetki", image: "/images/og/hetki.jpg" },
    { path: "/film", key: "film", side: "film", image: "/images/og/film.jpg" },
  ],
  // og:image-kuvien koko (scripts/build-og-images.swift)
  imageWidth: 1200,
  imageHeight: 630,
  // JSON-LD Organization. Yhteystiedot tulevat site.js:stä. Film-puolen sivuilla
  // ei ole tätä merkintää, jotta puolet eivät mainitse toisiaan.
  organization: {
    legalName: "Hetki Company Oy",
    alternateName: "Hetki",
    logo: "/logo512.png",
    addressCountry: "FI",
  },
};

// Reitin asetukset; tuntematon reitti saa portin tiedot (App.js ohjaa sen porttiin).
// Loppukauttaviiva ei vaikuta (/hetki/ = /hetki).
export const seoPage = (pathname) => {
  const path = pathname.replace(/(.)\/+$/, "$1");
  return seo.pages.find((p) => p.path === path) ?? seo.pages[0];
};
